<template>
  <FormContainer>
    <template #title>Maître d'apprentissage 1/1</template>
    <template #content>
      <!-- Déactiver recherche PRT-640 -->
      <div
        class="form__bloc"
        v-if="!readonly && saisieAdherent && false"
      >
        <RechercheSalarie
          mode="salaries"
          :id-demande="model!.id"
          @selected="onRechercheMaitreApprentissage('principal', $event)"
          class="col-12 col-md-18 col-sm-36"
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_70"
          v-model="nomNaissanceMaitreModel"
          label="Nom de naissance"
          :required="meta.tutorat?.maitreApprentissage?.nomNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissage?.nomNaissance?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_7Model"
          v-model="nomMaitreModel"
          label="Nom d'usage (si différent)"
          :required="meta.tutorat?.maitreApprentissage?.nom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissage?.nom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM_NAIS"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_72"
          v-model="prenomMaitreModel"
          label="Prénom (le premier selon l'état civil)"
          :required="meta.tutorat?.maitreApprentissage?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissage?.prenom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperDropdown
          id="field_73"
          v-model="sexeMaitreModel"
          label="Sexe"
          :required="meta.tutorat?.maitreApprentissage?.sexe?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissage?.sexe?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="sexeItems"
          :readonly
        />
        <WrapperInputDate
          id="field_73"
          v-model="dateNaissanceMaitreModel"
          label="Date de naissance"
          :required="meta.tutorat?.maitreApprentissage?.dateNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissage?.dateNaissance?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE_NAIS"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_74"
          v-model="emailMaitreModel"
          label="Email"
          :required="meta.tutorat?.maitreApprentissage?.email?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissage?.email?.$messageErreurDirty!"
          hint="64 caractères max. XXXX@XXX.XX"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_EMAIL"
          :maxlength="64"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_75"
          v-model="emploiOccupeMaitreModel"
          label="Emploi occupé"
          :required="meta.tutorat?.maitreApprentissage?.emploiOccupe?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissage?.emploiOccupe?.$messageErreurDirty!"
          hint="100 caractères max"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_EMPLOI_TUTEUR"
          :maxlength="100"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_76"
          v-model="diplomeMaitreModel"
          label="Diplôme ou titre le plus élevé obtenu"
          :required="
            meta.tutorat?.maitreApprentissage?.diplomeOuTitreLePlusEleveObtenu?.$status === PropertyStatus.Required
          "
          :alertLabel="meta.tutorat?.maitreApprentissage?.diplomeOuTitreLePlusEleveObtenu?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :readonly
          deletable
        />
        <WrapperDropdown
          id="field_77"
          v-model="niveauDiplomeMaitreModel"
          label="Niveau de diplôme ou titre le plus élevé obtenu"
          :required="
            meta.tutorat?.maitreApprentissage?.niveauDiplomeOuTitreLePlusEleveObtenu?.$status ===
            PropertyStatus.Required
          "
          :alertLabel="meta.tutorat?.maitreApprentissage?.niveauDiplomeOuTitreLePlusEleveObtenu?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="lov.NiveauDiplome"
          key-id="code"
          key-label="intitule"
          :readonly
        />
      </div>
      <div class="form__bloc">
        <BasicButton
          v-if="!model?.tutorat?.maitreApprentissageSecondaire"
          label="Ajouter un autre maître d'apprentissage"
          iconName="add"
          type="secondary"
          class="col-16 col-md-18 col-sm-36"
          @click="ajouterSecondMaitre"
          :disabled="readonly"
        />
      </div>
    </template>
  </FormContainer>
  <FormContainer v-if="model?.tutorat?.maitreApprentissageSecondaire">
    <template #title>Maître d'apprentissage 2/2</template>
    <template #content>
      <div
        class="form__bloc"
        v-if="!readonly && saisieAdherent && false"
      >
        <RechercheSalarie
          mode="salaries"
          :id-demande="model!.id"
          @selected="onRechercheMaitreApprentissage('secondaire', $event)"
          class="col-12 col-md-18 col-sm-36"
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          id="field_80"
          v-model="nomNaissanceMaitre2Model"
          label="Nom de naissance"
          :required="meta.tutorat?.maitreApprentissageSecondaire?.nomNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissageSecondaire?.nomNaissance?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_81"
          v-model="nomMaitre2Model"
          label="Nom d'usage (si différent)"
          :required="meta.tutorat?.maitreApprentissageSecondaire?.nom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissageSecondaire?.nom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM_NAIS"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_82"
          v-model="prenomMaitre2Model"
          label="Prénom (le premier selon l'état civil)"
          :required="meta.tutorat?.maitreApprentissageSecondaire?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissageSecondaire?.prenom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperDropdown
          id="field_83"
          v-model="sexeMaitre2Model"
          label="Sexe"
          :required="meta.tutorat?.maitreApprentissageSecondaire?.sexe?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissageSecondaire?.sexe?.$messageErreurDirty!"
          class="col-12 col-md-18 col-sm-36"
          :items="sexeItems"
          :readonly
        />
        <WrapperInputDate
          id="field_84"
          v-model="dateNaissanceMaitre2Model"
          label="Date de naissance"
          :required="meta.tutorat?.maitreApprentissageSecondaire?.dateNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissageSecondaire?.dateNaissance?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE_NAIS"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_85"
          v-model="emailMaitre2Model"
          label="Email"
          :required="meta.tutorat?.maitreApprentissageSecondaire?.email?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissageSecondaire?.email?.$messageErreurDirty!"
          hint="64 caractères max. XXXX@XXX.XX"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_EMAIL"
          :maxlength="64"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_86"
          v-model="emploiOccupeMaitre2Model"
          label="Emploi occupé"
          :required="meta.tutorat?.maitreApprentissageSecondaire?.emploiOccupe?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.maitreApprentissageSecondaire?.emploiOccupe?.$messageErreurDirty!"
          hint="100 caractères max"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_EMPLOI_TUTEUR"
          :maxlength="100"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_87"
          v-model="diplomeMaitre2Model"
          label="Diplôme ou titre le plus élevé obtenu"
          :required="
            meta.tutorat?.maitreApprentissageSecondaire?.diplomeOuTitreLePlusEleveObtenu?.$status ===
            PropertyStatus.Required
          "
          :alertLabel="
            meta.tutorat?.maitreApprentissageSecondaire?.diplomeOuTitreLePlusEleveObtenu?.$messageErreurDirty!
          "
          class="col-12 col-md-18 col-sm-36"
          :readonly
          deletable
        />
        <WrapperDropdown
          id="field_88"
          v-model="niveauDiplomeMaitre2Model"
          label="Niveau de diplôme ou titre le plus élevé obtenu"
          :required="
            meta.tutorat?.maitreApprentissageSecondaire?.niveauDiplomeOuTitreLePlusEleveObtenu?.$status ===
            PropertyStatus.Required
          "
          :alertLabel="
            meta.tutorat?.maitreApprentissageSecondaire?.niveauDiplomeOuTitreLePlusEleveObtenu?.$messageErreurDirty!
          "
          class="col-12 col-md-18 col-sm-36"
          :items="lov.NiveauDiplome"
          key-id="code"
          key-label="intitule"
          :readonly
        />
      </div>
      <div class="form__bloc">
        <BasicButton
          label="Retirer le second maître d'apprentissage"
          iconName="minus-square"
          type="secondary"
          class="col-16 col-md-18 col-sm-36"
          @click="annulerSecondMaitre"
          :disabled="readonly || supprimerSecondMaitreDisabled"
        />
      </div>
    </template>
  </FormContainer>
  <div
    class="form__bloc"
    style="margin-bottom: 24px"
  >
    <WrapperCheckbox
      id="field_89"
      v-model="attestationTuteurTroisApprentisModel"
      label="Le ou les maîtres d'apprentissage ne suivent pas plus de 3 apprentis sur la même période"
      :alertLabel="meta.tutorat?.attestationTuteurTroisApprentis?.$messageErreurDirty!"
      :required="meta.tutorat?.attestationTuteurTroisApprentis?.$status === PropertyStatus.Required"
      :readonly
      class="col-36"
    />
    <WrapperCheckbox
      id="field_90"
      v-model="attestationTuteurFormationTuteurModel"
      label="Le ou les maîtres d'apprentissage ont suivi une formation de tuteur ces 5 dernières années"
      :alertLabel="meta.tutorat?.attestationTuteurFormationTuteur?.$messageErreurDirty!"
      :required="meta.tutorat?.attestationTuteurFormationTuteur?.$status === PropertyStatus.Required"
      :readonly
      class="col-36"
    />
    <WrapperCheckbox
      id="field_88"
      v-model="attestationTuteurCriteresEligibiliteModel"
      label="L’employeur atteste sur l’honneur que le ou les maitres d’apprentissage répondent à l’ensemble des critères d’éligibilité à cette fonction"
      :alertLabel="meta.tutorat?.attestationTuteurCriteresEligibilite?.$messageErreurDirty!"
      :required="meta.tutorat?.attestationTuteurCriteresEligibilite?.$status === PropertyStatus.Required"
      :readonly
      class="col-36"
    />
    <BasicText
      class="col-36"
      size="body-m"
    >
      Merci de vous référer à ce
      <BasicLink
        label="lien"
        @link-click="redirectExterne('https://www.akto.fr/recruter-en-alternance/le-tutorat/')"
      />
      pour connaître les critères d’éligibilité à cette fonction
    </BasicText>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import {
    EMPTY_MAITRE_APPRENTIS,
    type MaitreApprentissageDTO,
    type TutoratDTO,
  } from '@/features/api/extranet/dto/Demande/CAPP'
  import { RechercheSalarie } from '@/features/interface/demande/shared/components/salaries'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { useDemandeCAPPStore } from '@/features/interface/demande/capp/useDemandeCAPPStore'
  import {
    FormContainer,
    HINT_DATE,
    PLACEHOLDER_DATE_NAIS,
    PLACEHOLDER_EMAIL,
    PLACEHOLDER_EMPLOI_TUTEUR,
    PLACEHOLDER_NOM,
    PLACEHOLDER_NOM_NAIS,
    PLACEHOLDER_PRENOM,
  } from '@/features/interface/demande/shared'
  import { objectIsEmpty, sexeItems } from '@/features/interface/shared/tools'
  import { useDialog } from '@/features/interface/dialog/useDialog'
  import type { DialogResult } from '@/features/interface/dialog/types'
  import type { SalarieRechercheDTO } from '@/features/api/extranet/dto/Demande/shared'
  import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
  import { redirectExterne } from '@/features/shared/tools/url'

  const store = useDemandeCAPPStore()
  const { setupFieldWithKey, setupCustomUpdater } = store
  const { meta, model, lov, readonly, typeContextCourant, estTT } = storeToRefs(store)

  const saisieAdherent = computed(() => typeContextCourant.value === TypesContextesAutorisesEnum.Adherent)

  const nomNaissanceMaitreModel = setupFieldWithKey<string>('tutorat.maitreApprentissage.nomNaissance', true)
  const nomMaitreModel = setupFieldWithKey<string>('tutorat.maitreApprentissage.nom', true)
  const prenomMaitreModel = setupFieldWithKey<string>('tutorat.maitreApprentissage.prenom', true)
  const dateNaissanceMaitreModel = setupFieldWithKey<string>('tutorat.maitreApprentissage.dateNaissance', true)
  const emailMaitreModel = setupFieldWithKey<string>('tutorat.maitreApprentissage.email', true)
  const emploiOccupeMaitreModel = setupFieldWithKey<string>('tutorat.maitreApprentissage.emploiOccupe')
  const sexeMaitreModel = setupFieldWithKey<string>('tutorat.maitreApprentissage.sexe')
  const diplomeMaitreModel = setupFieldWithKey<string>('tutorat.maitreApprentissage.diplomeOuTitreLePlusEleveObtenu')
  const niveauDiplomeMaitreModel = setupFieldWithKey<string>(
    'tutorat.maitreApprentissage.niveauDiplomeOuTitreLePlusEleveObtenu',
  )

  const nomNaissanceMaitre2Model = setupFieldWithKey<string>('tutorat.maitreApprentissageSecondaire.nomNaissance', true)
  const nomMaitre2Model = setupFieldWithKey<string>('tutorat.maitreApprentissageSecondaire.nom', true)
  const prenomMaitre2Model = setupFieldWithKey<string>('tutorat.maitreApprentissageSecondaire.prenom', true)
  const dateNaissanceMaitre2Model = setupFieldWithKey<string>(
    'tutorat.maitreApprentissageSecondaire.dateNaissance',
    true,
  )
  const emailMaitre2Model = setupFieldWithKey<string>('tutorat.maitreApprentissageSecondaire.email', true)
  const emploiOccupeMaitre2Model = setupFieldWithKey<string>('tutorat.maitreApprentissageSecondaire.emploiOccupe')
  const sexeMaitre2Model = setupFieldWithKey<string>('tutorat.maitreApprentissageSecondaire.sexe', false)
  const diplomeMaitre2Model = setupFieldWithKey<string>(
    'tutorat.maitreApprentissageSecondaire.diplomeOuTitreLePlusEleveObtenu',
  )
  const niveauDiplomeMaitre2Model = setupFieldWithKey<string>(
    'tutorat.maitreApprentissageSecondaire.niveauDiplomeOuTitreLePlusEleveObtenu',
  )

  const attestationTuteurCriteresEligibiliteModel = setupFieldWithKey<boolean>(
    'tutorat.attestationTuteurCriteresEligibilite',
  )
  const attestationTuteurTroisApprentisModel = setupFieldWithKey<boolean>('tutorat.attestationTuteurTroisApprentis')
  const attestationTuteurFormationTuteurModel = setupFieldWithKey<boolean>('tutorat.attestationTuteurFormationTuteur')

  const supprimerSecondMaitreDisabled = computed(() =>
      estTT.value && model.value?.typePublic === 'Interimaire'
  )
  const annulerSecondMaitre = setupCustomUpdater((patch) => {
    patch.tutorat!.maitreApprentissageSecondaire = null
  })
  const ajouterSecondMaitre = setupCustomUpdater((patch) => {
    patch.tutorat = {
      ...patch.tutorat,
      maitreApprentissageSecondaire: {},
    } as TutoratDTO
  })

  type TypeMaitreApprentissage = 'principal' | 'secondaire'
  const remplacerMaitreApprentissage = setupCustomUpdater<{
    typeMaitre: TypeMaitreApprentissage
    maitre: SalarieRechercheDTO
  }>((patch, options) => {
    const newMaitre: MaitreApprentissageDTO = {
      ...EMPTY_MAITRE_APPRENTIS,
      dateNaissance: options.maitre.dateNaissance ?? null,
      email: options.maitre.email ?? null,
      nom: options.maitre.nom ?? null,
      nomNaissance: options?.maitre.nomNaissance ?? null,
      prenom: options?.maitre?.prenom ?? null,
      sexe: options?.maitre?.sexe ?? null,
    }

    if (options.typeMaitre === 'principal') {
      patch.tutorat!.maitreApprentissage = newMaitre
    } else {
      patch.tutorat!.maitreApprentissageSecondaire = newMaitre
    }
  })

  const onRechercheMaitreApprentissage = async (
    typeMaitre: 'principal' | 'secondaire',
    maitre: SalarieRechercheDTO,
  ) => {
    let reponse: DialogResult = 'Ok'

    const maitreEnCours =
      typeMaitre === 'principal'
        ? model.value?.tutorat?.maitreApprentissage
        : model?.value?.tutorat?.maitreApprentissageSecondaire

    if (objectIsEmpty(maitreEnCours) === false) {
      const dialog = useDialog()
      reponse = await dialog.showDialog({
        message: ['Cette opération entrainera le remplacement de la saisie existante.', "Confirmez-vous l'opération ?"],
        type: 'OkCancel',
        closable: true,
        title: 'Attention',
      })
    }
    if (reponse === 'Ok') {
      remplacerMaitreApprentissage({ typeMaitre, maitre })
    }
  }
</script>
